import React, { useEffect, useState } from "react";
import { Button,CircularProgress } from "@material-ui/core";
import { usageService, commonService,appService } from "../../../services/index";
import { BillingStyles } from "../e_billing-style";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";
import moment from "moment";
import { store } from "../../../helpers";

export default function E_StatementOfAccount(props) {
  const classes = BillingStyles();
  const [load, setLoad] = useState(false);
  const[relation,setRelation]=useState()
  let bearer = localStorage.getItem("bearer")
    const [mobile,setMobile] = useState('')
    const [perId, setPerId] = useState()
    const [acctId, setAcctId] = useState()
  let labels = {};
  const {email} = useSelector((state) => state.profileDetails)
  const {customerNumber} = useSelector((state) => state.meterDetails)
  if (appService.getLabels()) {
    labels = appService.getLabels().getLabels.BILLING_HISTORY;
    labels={
      "BILLING_STATMENTOFACCOUNTTOOLTIP":labels.BILLING_STATMENTOFACCOUNTTOOLTIP,
    }
  }
  const dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );
  const DAY_MONTH_YEAR_FORMAT = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  const languageCode = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
);

let userDetails = useSelector((store)=>store?.profileDetails);

 let accountDetails=useSelector((state)=>state.accountInformation)
 let PRIMARYEMAIL;
 useEffect(()=>{
  if (Array.isArray(accountDetails?.personDetailList)) {
    accountDetails.personDetailList.forEach((element) => {
   if (element["C1-Person"].personId === accountDetails.personAcccountDetail.personAccountList[0].personId) {
     PRIMARYEMAIL=element['C1-Person']["personContactDetail"];
}
})
 }else{
   if (accountDetails.personDetailList["C1-Person"].personId === accountDetails.personAcccountDetail.personAccountList[0].personId) {
    if(Array.isArray(accountDetails?.personDetailList['C1-Person']["personContactDetail"])){
      PRIMARYEMAIL=(accountDetails?.personDetailList['C1-Person']["personContactDetail"]);
     }else{
       PRIMARYEMAIL=accountDetails?.personDetailList['C1-Person']["personContactDetail"]
     }
     
 }
 }
 if(Array.isArray(PRIMARYEMAIL)){
    let filteredMobile = PRIMARYEMAIL?.filter(e=>e?.contactDetailPrimary=="C1YS")
    setMobile(filteredMobile[0]?.contactDetailValue)
 }else{
   setMobile(PRIMARYEMAIL?.contactDetailValue)
 }
},[accountDetails])

useEffect(()=>{
  if(userDetails?.phoneNumber){
    setMobile(userDetails?.phoneNumber)
  }
  },[userDetails])

  const getMainPhone = (cNo) => {
    let allTenants = store.getState().accountInformation.personAcccountDetail
      .personAccountList;
    let ownersArray = [];
    let isOwnerOrTenant;
    if (Array.isArray(allTenants)) {
      isOwnerOrTenant = allTenants
        .filter((e) => e?.customerNumber == cNo)
        .map((e) => {
          return { relation: e?.accountRelType, personId: e?.personId };
        });
        setRelation(isOwnerOrTenant[0]?.relation?isOwnerOrTenant[0]?.relation:'')
      if (isOwnerOrTenant[0]?.relation == "TENANT" || isOwnerOrTenant[0]?.relation == "MAIN") {
       // let bearer = localStorage.getItem("bearer");
       bearer = JSON.parse(bearer)
        let allAccounts;
        if (
          Array.isArray(
            bearer?.accountDetails.accountSummary.personDetailList
          )
        ) {
          allAccounts = bearer?.accountDetails.accountSummary.personDetailList.filter(
            (e) => {
              return (
                e["C1-Person"]?.personId == isOwnerOrTenant[0]["personId"]
              );
            }
          );
          let phn = allAccounts[0]["C1-Person"].personContactDetail.find((e)=>e?.contactDetailPrimary=="C1YS");
          let mobileNo;
          if (Array.isArray(phn)) {
            mobileNo = allAccounts[0]["C1-Person"].personContactDetail
              .filter((e) => e?.contactDetailPrimary == "C1YS")
              ?.map((e) => e?.contactDetailValue);
              setMobile(mobileNo[0])
          }else{
            mobileNo = phn['contactDetailValue']
            setMobile(mobileNo)
          }
  
         
        }
      }
    }
  };
  useEffect(()=>{
    getMainPhone(customerNumber)
  },[customerNumber])

  useEffect(()=>{
    //fetching accountId,PersonId based on customerNumber
    let {accountId,personId} = accountDetails?.personAcccountDetail?.personAccountList.find(e=>e.customerNumber==customerNumber)
    setAcctId(accountId)
    setPerId(personId)

  },[customerNumber])



  function statementDownload() {
    if(languageCode){
    const accountStatement = "ACCOUNT_STATEMENT";
    let startDate= moment(props.fromDate, dateFormat).subtract(1, 'day').format(dateFormat);
    let endDate =moment(props.toDate,dateFormat).format(dateFormat)
    setLoad(true);
      usageService
      .downloadData(props.accountID, customerNumber,accountStatement, "", "",mobile,startDate,endDate,languageCode,"","","","","","","","","","","","","","","","","",acctId,perId)
      .then(
        (res) => {
          let data = res?.data?.data?.getBase64Document;
          if(data )
          {
            commonService.downloadPdf(data, props.title)
          }
          props.setFromDate(null);
          props.setToDate(null);
          if(props.isDialog && res?.status !== 204)
          {
            props.setOpen(false);
          }
          setLoad(false);
          if(res?.status === 204){
             props.setNoContent(true);
          }
        },
        (error) => {
          setLoad(false);
          props.setFromDate(null);
          props.setToDate(null);
        }
      );
  }}

  useEffect(()=>{
    if(props.isDisable){
      localStorage.removeItem("enabled_state")
    }else{
      localStorage.setItem("enabled_state",1)
    }

  },[props.isDisable])

  const handleBeforeUnload=(e)=>{
    e.preventDefault()
    e.returnValue = '';
  }
  
  // useEffect(()=>{
  //   if(!props.isDisable){
  //    window.addEventListener("beforeunload", handleBeforeUnload,{capture:true});  
  //   }
  //   else{
  //       window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true});
  //   }
  //   return () => window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
  // },[props.isDisable])

  return (
    <React.Fragment>
      {load ? (
        <Tooltip title={labels.BILLING_STATMENTOFACCOUNTTOOLTIP}>
          <Button
            color="secondary"
            variant="contained"
            className={`textTransform loadButton ${classes.forthButton}`}
            endIcon={<CircularProgress className={classes.loadingButton} size={18} />}
            disabled
          >
            {props.label}
          </Button>
        </Tooltip>
      ) : (
          <Button
            color="secondary"
            variant="contained"
            onClick={
              statementDownload
            }
            className={`textTransform ${classes.forthButton}`}
            size="medium"
            disabled={props.isDisable}
          >
            {props.label}
          </Button>
      )}
    </React.Fragment>
  );
}

